import React from "react";
import Footer from "../Footer/Footer";
import { Typography, Button, Image } from "antd";
import "./Tokens.css";
import inex from "../../assets/coinAnimations/inex_4_11zon.png";
import first from "./first.svg";
import second from "./second.svg";
import third from "./third.svg";
import fourth from "./fourth.svg";
import fifth from "./fifth.svg";
import fifthdark from "./fifthdark.svg";
import tokenguy from "./banner.png";
import hands from "../../assets/tokenpages/inex/hand.png";
import hand_dark from "../../assets/tokenpages/inex/hand_dark.png";
import uses from "../../assets/tokenpages/inex/uses.png";
import uses_dark from "../../assets/tokenpages/inex/uses_dark.png";
import table from "../../assets/tokenpages/inex/black_mode_table.svg";
import table_dark from "../../assets/tokenpages/inex/white_mode_table.svg";
import { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";

import {
  baseCEXURL,
  baseDEXURL,
  decodeJWT,
  getUserShortToken,
} from "../../services/api";
import { useMediaQuery } from "@mui/material";
const { Text } = Typography;

const useStyles = makeStyles((theme: any) => ({
  disclaimerContainer: {
    maxWidth: "1500px",
    margin: "auto",
    padding: "20px",
    marginTop: "100px",
  },
  heading: {
    fontSize: "12px",
    marginBottom: "10px",
    maxWidth: "900px",
    color: theme.palette.text.secondary,
  },
  subheading: {
    fontSize: "11px",
    marginBottom: "12px",
    maxWidth: "900px",
    color: theme.palette.text.secondary,
  },
  text: {
    fontSize: "10px",
    lineHeight: "1.5",
    marginBottom: "16px",
    maxWidth: "900px",
    color: theme.palette.text.secondary,
  },
  list: {
    paddingLeft: "20px",
    marginBottom: "10px",
    maxWidth: "900px",
    color: theme.palette.text.secondary,
  },
  listItem: {
    fontSize: "10px",
    lineHeight: "1.5",
    marginBottom: "6px",
    maxWidth: "900px",
    color: theme.palette.text.secondary,
  },

  link: {
    textDecoration: "none",
    color: theme.palette.text.secondary,
  },
}));

const IndexxEX = () => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const [shortToken, setShortToken] = useState(null);
  const [theme, setTheme] = useState(
    localStorage.getItem("selectedTheme") || "dark"
  );
  const classes = useStyles();

  useEffect(() => {
    async function checkIsAuthenicated() {
      const isAuthenticated = localStorage.getItem("access_token");
      const email = localStorage.getItem("email");
      let sToken;

      if (email) {
        sToken = await getUserShortToken(email);
        setShortToken(sToken.data);
      } else if (isAuthenticated) {
        let decodedValue: any = await decodeJWT(isAuthenticated);
        sToken = await getUserShortToken(decodedValue?.email);
        setShortToken(sToken.data);
      }
    }
    checkIsAuthenicated();
  }, []);

  useEffect(() => {
    const handleStorageChange = (event: any) => {
      console.log(event);
      setTheme(event.currentTarget.localStorage.selectedTheme);
    };

    window.addEventListener("storage", handleStorageChange);
    // window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      // window.removeEventListener('resize', handleWindowSizeChange);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  console.log("theme in inex is :", theme);

  return (
    <>
      {isMobile ? (
        <div
          className="scan-container how-it-works flex-direction-column"
          style={{ gap: "20px", marginTop: "100px" }}
        >
          <Image
            src={inex}
            preview={false}
            width={130}
            style={{ marginTop: "20px", marginBottom: "10px" }}
          ></Image>
          <Text
            style={{
              fontSize: 22,
              opacity: "90%",
              marginBottom: 30,
              color: "var(--body_color)",
              textAlign: "center",
            }}
          >
            indexx Exchange
            <br />
            INEX
          </Text>
          <Image
            src={tokenguy}
            preview={false}
            style={{ width: "100%", marginTop: "100px" }}
          ></Image>

          <div className="row center d-flex justify-content-center align-items-center">
            <img
              src={theme === "dark" ? hand_dark : hands}
              style={{
                marginTop: "160px",
                marginBottom: "20px",
                width: "fit-content",
              }}
            />
          </div>

          <a
            href={
              shortToken
                ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=INEX`
                : `${baseCEXURL}/update/home?buyToken=INEX`
            }
            style={{ textAlign: "center" }}
          >
            <Button
              style={{
                textAlign: "center",
                marginTop: "-100px",
                borderRadius: 5,
                marginLeft: -36,
                height: "55px",
              }}
              type="primary"
              className="secondButton"
            >
              {" "}
              Buy Tokens
            </Button>
          </a>

          <Image
            src={theme === "dark" ? uses_dark : uses}
            preview={false}
            style={{ marginTop: "200px", width: "fit-content" }}
          ></Image>

          <a
            href={
              shortToken
                ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=INEX`
                : `${baseCEXURL}/update/home?buyToken=INEX`
            }
            style={{ textAlign: "center" }}
          >
            <Button
              style={{
                textAlign: "center",
                borderRadius: 5,
                width: 268,
                marginTop: 54,
                height: "55px",
              }}
              type="primary"
              className="secondButton"
            >
              {" "}
              Buy Tokens
            </Button>
          </a>
        </div>
      ) : (
        <div
          className="scan-container how-it-works flex-direction-column  "
          style={{ marginTop: "100px" }}
        >
          <Image
            src={inex}
            preview={false}
            width={130}
            style={{ marginTop: "20px", marginBottom: "10px" }}
          ></Image>
          <Text
            style={{
              fontSize: 22,
              opacity: "90%",
              marginBottom: 30,
              color: "var(--body_color)",
            }}
          >
            indexx Exchange / INEX
          </Text>
          <Image
            src={tokenguy}
            preview={false}
            style={{ width: "100%", marginTop: "150px" }}
          ></Image>

          <div className="row center d-flex justify-content-center">
            <Image
              src={first}
              preview={false}
              width={1025}
              style={{ marginTop: "260px", marginBottom: "-40px" }}
            ></Image>
          </div>

          <a
            href={
              shortToken
                ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=INEX`
                : `${baseCEXURL}/update/home?buyToken=INEX`
            }
            style={{ textAlign: "center" }}
          >
            <Button
              style={{
                textAlign: "center",
                marginTop: "-120px",
                borderRadius: 5,
                marginLeft: -36,
              }}
              type="primary"
              className="secondButton"
            >
              {" "}
              Buy Tokens
            </Button>
          </a>

          <Image
            src={theme === "light" ? table_dark : table}
            preview={false}
            width={1041}
            style={{ marginTop: "200px" }}
          ></Image>

          <Image
            src={second}
            preview={false}
            width={399}
            style={{ marginTop: "380px" }}
          ></Image>

          <Image
            src={third}
            preview={false}
            width={794.17}
            style={{ marginTop: "308px" }}
          ></Image>

          <Image
            src={fourth}
            preview={false}
            width={440}
            style={{ marginTop: "287px" }}
          ></Image>

          <a
            href={
              shortToken
                ? `${baseCEXURL}/update/home?signInToken=${shortToken}&buyToken=INEX`
                : `${baseCEXURL}/update/home?buyToken=INEX`
            }
            style={{ textAlign: "center" }}
          >
            <Button
              style={{
                textAlign: "center",
                borderRadius: 5,
                width: 268,
                marginTop: 54,
              }}
              type="primary"
              className="secondButton"
            >
              {" "}
              Buy Tokens
            </Button>
          </a>
        </div>
      )}
      <div className={classes.disclaimerContainer}>
        <h1 className={classes.heading}>xTokens Asset Wallet Disclaimer</h1>
        <p className={classes.text}>
          This xTokens Asset Wallet Disclaimer (“Disclaimer”) is issued by <strong>Indexx.ai</strong> (the “Company”) and applies to all users (“User” or “You”) holding <strong>xTokens</strong> within the Company’s platform. By using the Company’s asset wallet and holding xTokens, you agree to the terms and limitations outlined in this Disclaimer.
        </p>
       
        <h2 className={classes.subheading}>1. xTokens Withdrawal Restrictions</h2>
        <h3 className={classes.subheading}>1.1 Lock-In Period</h3>
        <p className={classes.text}>
          All xTokens held within the Company's platform are <strong>subject to a mandatory lock-in period</strong> until the Company’s <strong>Initial Coin Offering (ICO)</strong> or formal <strong>public launch</strong>.<br /><br />
          <ul className={classes.list}>
            <li className={classes.listItem}><strong>During this period, xTokens cannot be withdrawn, sold, exchanged, or converted</strong> into fiat, other cryptocurrencies, or third-party assets.</li>
            <li className={classes.listItem}>This restriction applies <strong>regardless of account status, location, or investment duration</strong>.</li>
          </ul>
        </p>
        <h3 className={classes.subheading}>1.2 INEX Auto-Increment Policy</h3>
        <p className={classes.text}>
          The native INEX token is programmed to <strong>automatically increase in value by $0.25 every quarter</strong> (90-day period) until the Company goes public or launches its ICO. This increment is applied to the internal valuation and reflected across all INEX balances held on the platform.
          <ul className={classes.list}>
            <li className={classes.listItem}>This auto-increment feature is <strong>non-compounding</strong> and is <strong>automated</strong> based on a calendar schedule.</li>
            <li className={classes.listItem}>This policy does not imply or guarantee market liquidity at the incremented value until post-ICO or public launch.</li>
          </ul>
        </p>
        <h3 className={classes.subheading}>1.3 Acknowledgment of Risk</h3>
        <p className={classes.text}>By holding xTokens, you acknowledge and accept the following risks:</p>
        <ul className={classes.list}>
          <li className={classes.listItem}><strong>Regulatory Risks:</strong> Legal or policy changes may impact your ability to use or convert xTokens in the future.</li>
          <li className={classes.listItem}><strong>Market Volatility:</strong> Valuations may fluctuate and are not guaranteed.</li>
          <li className={classes.listItem}><strong>Operational Risks:</strong> Technical issues, platform updates, or unforeseen disruptions may impact access to or performance of the asset wallet.</li>
        </ul>
       
        <h2 className={classes.subheading}>2. Limitation of Liability</h2>
        <h3 className={classes.subheading}>2.1 No Guarantee of Value</h3>
        <p className={classes.text}>
          The Company makes <strong>no representations or warranties</strong> regarding the future valuation or liquidity of xTokens, including INEX or any other  Indexx-issued  asset. Market pricing, future listings, or token utility are <strong>not guaranteed</strong>.
        </p>
        <h3 className={classes.subheading}>2.2 Security and Account Responsibility</h3>
        <p className={classes.text}>
          Users are <strong>solely responsible</strong> for maintaining the security and confidentiality of their login credentials and account data.
          <ul className={classes.list}>
            <li className={classes.listItem}>Indexx.ai is <strong>not liable</strong> for any loss resulting from:
              <ul className={classes.list}>
                <li className={classes.listItem}>Unauthorized access</li>
                <li className={classes.listItem}>Account breaches</li>
                <li className={classes.listItem}>User negligence or failure to use available security features</li>
              </ul>
            </li>
          </ul>
        </p>
       
        <h2 className={classes.subheading}>3. Governing Law & Dispute Resolution</h2>
        <ul className={classes.list}>
          <li className={classes.listItem}>This Disclaimer is governed by the <strong>laws of the State of California, United States</strong>.</li>
          <li className={classes.listItem}>Any disputes or claims arising under this Disclaimer shall be resolved through <strong>binding arbitration in California</strong>.</li>
        </ul>
        <ul className={classes.list}>
          <li className={classes.listItem}><strong>Users expressly waive any right to participate in class-action lawsuits</strong> or group arbitration proceedings against Indexx.ai or its affiliates.</li>
        </ul>
       
        <h2 className={classes.subheading}>4. Contact Information</h2>
        <p className={classes.text}>
          For any questions, clarifications, or disputes related to xTokens or this Disclaimer, please contact us at:
        </p>
        <p className={classes.text}><span role="img" aria-label="email">📧</span> <strong>support@indexx.ai</strong><br /><span role="img" aria-label="web">🌐</span> <strong>Indexx.ai</strong><br /><span role="img" aria-label="link">🔗</span> <a href="https://indexx.ai" className={classes.link} target="_blank" rel="noopener noreferrer">https://indexx.ai</a></p>
       
        <p className={classes.text}>
          By continuing to use the Indexx.ai asset wallet and holding any xToken, you confirm that you have <strong>read, understood, and agreed</strong> to the full contents of this Disclaimer and accept all associated terms, risks, and restrictions.
        </p>
      </div>
      <Footer></Footer>
    </>
  );
};

export default IndexxEX;
